import { render } from "./HostInfo.vue?vue&type=template&id=008c7b0d"
import script from "./HostInfo.vue?vue&type=script&lang=js"
export * from "./HostInfo.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__